module.exports = __webpack_public_path__ + "img/File.1dc82ae5.svg";